/* eslint-disable @typescript-eslint/no-explicit-any */

import { getTranslation, i18nReactive } from "../../app/i18/i18tn";

import { DivWithSpinner } from "@tedivo/tedivo-ui";
import { I18nComponentRegisterer } from "@tedivo/tedivo-i18";
import ICustomError from "../types/ICustomError";
import { IntegratedDialogError } from "@tedivo/tedivo-ui";
import SlButton from "@shoelace-style/shoelace/dist/components/button/button";
import { TedivoForm } from "@tedivo/tedivo-form";
import { removeChildren } from "@tedivo/tedivo-dom-helpers";

export abstract class ComponentWithFormAndNode<
  T extends Record<string, any>,
> extends HTMLElement {
  public currentFormAndNode?: IFormAndNode<T> | IFormAndNode<IEmpty>;
  public divWithSpinner: DivWithSpinner;
  public dialogError: IntegratedDialogError;
  public i18nCR: I18nComponentRegisterer;

  private onDissmissDialog: (() => void) | undefined = undefined;

  constructor() {
    super();

    this.dialogError = new IntegratedDialogError(
      this,
      false,
      getTranslation("general:common.close"),
      () => {
        if (this.onDissmissDialog) this.onDissmissDialog();
      },
    );
    this.i18nCR = new I18nComponentRegisterer(i18nReactive);
    this.divWithSpinner = document.createElement("div-spinner-element");
  }

  /** Replaces the UI */
  public setCurrentFormAndNode(fan: typeof this.currentFormAndNode) {
    this.currentFormAndNode = fan;

    if (fan?.node) {
      this.divWithSpinner.setLoading(false);
      removeChildren(this.divWithSpinner);
      this.divWithSpinner.appendChild(fan.node);
    }
  }

  public showDialog = (
    e: ICustomError,
    title = `errors:errorHasOcurred`,
    onDissmissDialog?: () => void,
  ) => {
    if (onDissmissDialog) this.onDissmissDialog = onDissmissDialog;

    this.dialogError.show(
      getTranslation(title),
      getTranslation(typeof e === "string" ? e : e.translationKey),
    );

    console.error(e);
  };
}

export interface IFormAndNode<T extends Record<string, any>> {
  node: HTMLElement;
  form?: TedivoForm<T>;
  submitButton?: SlButton;
}

interface IEmpty {
  id?: string;
}
